// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1d44E","header":"PatientQuestionnaire_header__2gJLl","info":"PatientQuestionnaire_info__HMh0Z"};